import { Instance, types as t } from 'mobx-state-tree';

export const Category = t.model('Category', {
  id: t.identifier,
  name: t.string,
  is_global: t.boolean,
});

export type CategoryInstance = Instance<typeof Category>;
